import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

const CONFIRMATION_DURATION = 1500

export default class extends Controller {
  static get targets() {
    return ["form", "field", "name", "normalMode", "editor", "notice", "errorMessage", "successMessage"];
  }

  static get values() { return { resourceParamName: String, field: String }; }

  // The confirmation's own countdown is the only thing this controller holds; left armed it
  // reopens the editor and clears the mount's state after the teardown.
  disconnect() {
    clearTimeout(this.confirmationTimeoutId)
    this.confirmationTimeoutId = null
  }

  toggleEditor() {
    this.element.classList.add("editing")
    this.fieldTarget.focus()
    this.fieldTarget.setSelectionRange(this.fieldTarget.value.length, this.fieldTarget.value.length)
  }

  onNameChange() {
    if (this.fieldTarget.value.length === 0) { return; }

    this.noticeTarget.classList.remove("hidden")
    this.element.classList.remove("error")
    this.errorMessageTarget.querySelector("span").textContent = ""
  }

  clearName() {
    this.fieldTarget.value = ""
    this.fieldTarget.focus()
  }

  saveName(event) {
    event.preventDefault()

    // The action nests its params, and the before_action chain negotiates the
    // rejection format, so the body and both header halves are all load-bearing.
    const options = RequestHelper.defaultPatchOptions()
    options.headers = Object.assign({}, options.headers, {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json, text/plain, */*"
    })
    options.body = JSON.stringify({
      [this.resourceParamNameValue]: { [this.fieldValue]: this.fieldTarget.value }
    })

    fetch(this.formTarget.getAttribute("action"), options).
      then(response => response.json().then(body => ({ ok: response.ok, body: body }))).
      then(({ ok, body }) => { ok ? this.confirmSave(body) : this.reportRejection(body); }).
      catch(this.logFailedCall)
  }

  confirmSave(body) {
    this.nameTarget.textContent = body.resource.name
    this.editorTarget.classList.add("hidden")
    this.successMessageTarget.querySelector("span").textContent = body.message
    this.successMessageTarget.classList.remove("hidden")

    this.confirmationTimeoutId = setTimeout(() => {
      this.successMessageTarget.classList.add("hidden")
      this.editorTarget.classList.remove("hidden")
      this.element.classList.remove("error", "editing")
    }, CONFIRMATION_DURATION)
  }

  reportRejection(body) {
    this.element.classList.add("error")
    this.errorMessageTarget.querySelector("span").textContent = body.message
    this.noticeTarget.classList.add("hidden")
  }

  logFailedCall(response) {
    console.warn(response)
  }
}
